
class CardMeal extends HTMLElement {
  constructor() {
    super();
    this.setSelectedClass();
    this.querySelector(`[name="quantity"]`)?.addEventListener('change', () => {
      this.setSelectedClass();
      document.querySelector('meal-plan-summary').updateTable();
    });
    this.querySelector(`[name="id"]`).addEventListener('change', () => {
      this.updateMacro();
      document.querySelector('meal-plan-summary')?.updateTable();
    });

    const sizeSelectors = this.querySelectorAll('[size-selector]');
    sizeSelectors.forEach( sizeSelector => {
      sizeSelector.addEventListener('click', () => {
        const variantId = sizeSelector.getAttribute('data-variant-id');
        this.querySelector(`[name="id"]`).value = variantId
        this.updateMacro();
        document.querySelector('meal-plan-summary')?.updateTable();

        sizeSelectors.forEach( s => {
          s.classList.remove('active');
        });
        sizeSelector.classList.add('active');
      });
    });
  }

  updateMacro() {
    this.querySelectorAll('[macro-item]').forEach( macroItem => {
      const variantId = parseInt( macroItem.getAttribute('macro-item') );
      if( variantId == this.getVariantId() ) {
        macroItem.classList.add('in');
      } else {
        macroItem.classList.remove('in');
      }
    });
  }

  getDate() {
    return this.querySelector(`[name="properties[date]"]`)?.value || '';
  }

  getTime() {
    return this.querySelector(`[name="properties[time]"]`)?.value || '';
  }

  getVariantId() {
    return parseInt( this.querySelector(`[name="id"]`)?.value );
  }

  getQuantity() {
    return parseInt( this.querySelector(`[name="quantity"]`)?.value || 0 )
  }

  getPrice() {
    return parseInt( this.getSelectedOptionElement()?.getAttribute('data-price') );
  }

  getTotalPrice() {
    return this.getQuantity() * this.getPrice();
  }

  getSelectedOptionElement() {
    const select = this.querySelector(`[name="id"]`);
    return select.options[select.selectedIndex]
  }

  setSelectedClass() {
    if( this.getQuantity() > 0 ) {
      this.classList.add('selected');
    } else {
      this.classList.remove('selected');
    }
  }
}
customElements.define('card-meal', CardMeal);
